module.exports = __webpack_public_path__ + "static/car.9b459b3c.png";